export default "__VITE_ASSET__3245e50f__"